






import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import jQuery from 'jquery';

import { IDnDData } from './';
import { DnDDataWriter } from './DnDDataWriter';

@Component
export default class DnDSource extends Vue {

    @Prop(String) public dragHandleSelector?: string;
    @Prop(String) public dragImageSelector?: string;
    @Prop({ type: Function, required: true })
    public prepareDragData?: (data: IDnDData) => void;
    @Prop({ type: Function, required: false })
    public dropData?: (evt: DragEvent) => void;

    private mounted(): void {
        const selector = this.dragHandleSelector && this.dragHandleSelector.trim();
        if (selector && selector.length > 0) {
            this.handleDragStartOnSelector(selector);
            this.handleDragEndOnSelector(selector);
        } else {
            this.handleDragStartOnRootElement();
            this.handleDragEndOnRootElement();
        }
    }

    //#region drag start
    private onDragStart(evt: DragEvent): void {
        if (evt.dataTransfer) {
            this.setDragImage(evt);

            if (this.prepareDragData) {
                const writer = new DnDDataWriter();
                this.prepareDragData(writer);
                writer.write(evt.dataTransfer);
            }
        }
    }

    private handleDragStartOnRootElement(): void {
        this.handleDragStartOnElement(this.$el);
    }
    private handleDragStartOnSelector(selector: string): void {
        const elements = this.$el.querySelectorAll(selector);
        for (const element of elements) {
            this.handleDragStartOnElement(element);
        }
    }
    private handleDragStartOnElement(element: Element): void {

        const me = this;

        element.setAttribute('draggable', 'true');

        element.addEventListener('dragstart', ((evt: DragEvent) => {
            me.onDragStart(evt);
        }) as EventListener);
    }

    private setDragImage(evt: DragEvent): void {
        if (!evt.dataTransfer) { throw new Error('evt.dataTransfer is not set'); }

        if (typeof(evt.dataTransfer.setDragImage) === 'function') {
            let imageElement;

            const selector = this.dragImageSelector && this.dragImageSelector.trim();
            if (selector && selector.length > 0) {
                imageElement = this.$el.querySelector(selector);
            }

            if (!imageElement) {
                imageElement = this.$el;
            }

            if (imageElement) {

                let dragImageOffset;
                const jImageElement = jQuery(imageElement);
                const imageOffset = jImageElement.offset();
                const eventOffset = {
                    left: evt.clientX + window.pageXOffset,
                    top: evt.clientY + window.pageYOffset,
                };
                if (imageOffset) {
                    dragImageOffset = {
                        left: Math.min(
                            jImageElement.width() || 0,
                            Math.max(0, eventOffset.left - imageOffset.left)
                        ),
                        top: Math.min(
                            jImageElement.height() || 0,
                            Math.max(0, eventOffset.top - imageOffset.top)
                        ),
                    };
                }
                if (!dragImageOffset) {
                    dragImageOffset = { left: 0, top: 0 };
                }

                evt.dataTransfer.setDragImage(imageElement, dragImageOffset.left, dragImageOffset.top);
            }
        }
    }
    //#endregion

    //#region drag end
    private onDragEnd(evt: DragEvent): void {
        if (!evt) { throw new Error('DragEvent is not set'); }
        if (!evt.dataTransfer) { throw new Error('dataTransfer property of DragEvent is not set'); }
        if (!this.dropData) { throw new Error('dropData handler is not set'); }

        this.dropData(evt);
    }

    private handleDragEndOnRootElement(): void {
        this.handleDragEndOnElement(this.$el);
    }
    private handleDragEndOnSelector(selector: string): void {
        const elements = this.$el.querySelectorAll(selector);
        for (const element of elements) {
            this.handleDragEndOnElement(element);
        }
    }
    private handleDragEndOnElement(element: Element): void {

        const me = this;

        element.setAttribute('draggable', 'true');

        element.addEventListener('dragend', ((evt: DragEvent) => {
            me.onDragEnd(evt);
        }) as EventListener);
    }
    //#endregion
}
